import * as angular from "angular";
import {IHttpService, IQService} from "angular";
import {SplitService} from "../../commons/services/split-service.service";
import {ApiConfig} from "../../commons/models/api-config.model";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";

export class ReportsRequests {

  private base_url: any;

  /* @ngInject */
  constructor(private $http: IHttpService, private $q: IQService, private apiConfig: ApiConfig, private splitService: SplitService, private bringozLoaderService: BringozLoaderService) {
    this.base_url = this.apiConfig.baseUrl + `/reports`;
  }

  // ******************************
  //        Public methods
  // ******************************

  getDeliveriesReport(tq, from, to, createdFrom, createdTo, branchId, demandIds, supplyId, agentIds, groupBy, tagNames) {
    return this.$http.get(this.base_url + '/deliveries', {
      params: {
        siteId: this.splitService.getSiteId(),
        tq: tq,
        from: from,
        to: to,
        createdFrom: createdFrom,
        createdTo: createdTo,
        branchIds: branchId,
        demandIds: demandIds,
        supplyIds: supplyId,
        agentIds: agentIds,
        groupBy: groupBy,
        tagNames: tagNames,
        zoneId: this.splitService.getTimeZone()
      }
    })
      .then((response) => {
        return this._sendResponseData(response);
      })
      .catch((error) => {
        return this._sendError(error);
      })

  }

  // OLD!
  getDeliveriesTotal(tq, from, to, status, demandIds, supplyIds, agentIds, groupBy) {
    return this.$http.get(this.base_url + '/deliveriesTotal', {
      params: {
        siteId: this.splitService.getSiteId(),
        tq: tq,
        from: from,
        to: to,
        status: status,
        demandIds: demandIds,
        supplyIds: supplyIds,
        agentIds: agentIds,
        groupBy: groupBy
      }
    })
      .then((response) => {
        return this._sendResponseData(response);
      })
      .catch((error) => {
        return this._sendError(error);
      })

  }

  getDeliveriesTotals(tq, from, to, createdFrom, createdTo, branchId, demandIds, supplyId, agentIds, groupBy, tagNames) {
    return this.$http.get(this.base_url + '/deliveries/total', {
      params: {
        siteId: this.splitService.getSiteId(),
        tq: tq,
        from: from,
        to: to,
        createdFrom: createdFrom,
        createdTo: createdTo,
        branchIds: branchId,
        demandIds: demandIds,
        supplyIds: supplyId,
        agentIds: agentIds,
        groupBy: groupBy,
        tagNames: tagNames,
        zoneId: this.splitService.getTimeZone()
      }
    })
      .then((response) => {
        return this._sendResponseData(response);
      })
      .catch((error) => {
        return this._sendError(error);
      })
  }

  exportDeliveries(from, to, createdFrom, createdTo, demandIds, supplyIds, agentIds, tagNames) {
    return this.$http.get(this.base_url + '/deliveries/export', {
      params: {
        siteId: this.splitService.getSiteId(),
        from: from,
        to: to,
        createdFrom: createdFrom,
        createdTo: createdTo,
        demandIds: demandIds,
        supplyIds: supplyIds,
        agentIds: agentIds,
        status: status,
        tagNames: tagNames,
        zoneId: this.splitService.getTimeZone()
      },
      responseType: "arraybuffer"
    })
      .then((response) => {
        return this._sendResponseData(response);
      })
      .catch((error) => {
        return this._sendError(error);
      })
  }

  getRushHoursReport(tq, from, to, branchId, demandIds, groupBy) {
    return this.$http.get(this.base_url + '/rushHours', {
      params: {
        siteId: this.splitService.getSiteId(),
        tq: tq,
        from: from,
        to: to,
        branchIds: branchId,
        demandIds: demandIds,
        groupBy: groupBy,
        zoneId: this.splitService.getTimeZone()
      }
    })
      .then((response) => {
        return this._sendResponseData(response);
      })
      .catch((error) => {
        return this._sendError(error);
      })
  }

  getRushHoursTotalReport(from, to, branchId, demandIds, groupBy) {
    return this.$http.get(this.base_url + '/rushHours/total', {
      params: {
        siteId: this.splitService.getSiteId(),
        from: from,
        to: to,
        branchIds: branchId,
        demandIds: demandIds,
        groupBy: groupBy,
        zoneId: this.splitService.getTimeZone()
      }
    })
      .then((response) => {
        return this._sendResponseData(response);
      })
      .catch((error) => {
        return this._sendError(error);
      })
  }

  exportRushHours(from, to, branchIds, demandIds, groupBy) {
    return this.$http.get(this.base_url + '/rushHours/export', {
      params: {
        siteId: this.splitService.getSiteId(),
        from: from,
        to: to,
        branchIds: branchIds,
        demandIds: demandIds,
        groupBy: groupBy,
        zoneId: this.splitService.getTimeZone()
      },
      responseType: "arraybuffer"
    })
      .then((response) => {
        return this._sendResponseData(response);
      })
      .catch((error) => {
        return this._sendError(error);
      })
  }

  getDeliveriesCompletionReport(tq?, from?, to?, type?, groupBy?, branchId?, demandIds?, supplyId?, agentIds?) {
    return this.$http.get(this.base_url + '/deliveriesCompletion', {
      params: {
        siteId: this.splitService.getSiteId(),
        tq: tq,
        from: from,
        to: to,
        type: type,
        groupBy: groupBy,
        branchIds: branchId,
        demandIds: demandIds,
        supplyIds: supplyId,
        agentIds: agentIds,
        zoneId: this.splitService.getTimeZone()
      }
    })
      .then((response) => {
        return this._sendResponseData(response);
      })
      .catch((error) => {
        return this._sendError(error);
      })
  }

  getDeliveriesCompletionTotalReport(tq, from, to, type, branchId, demandIds, supplyId, agentIds) {
    return this.$http.get(this.base_url + '/deliveriesCompletion/total', {
      params: {
        siteId: this.splitService.getSiteId(),
        tq: tq,
        from: from,
        to: to,
        type: type,
        branchIds: branchId,
        demandIds: demandIds,
        supplyIds: supplyId,
        agentIds: agentIds,
        zoneId: this.splitService.getTimeZone()
      }
    })
      .then((response) => {
        return this._sendResponseData(response);
      })
      .catch((error) => {
        return this._sendError(error);
      })
  }

  exportDeliveriesCompletion(from?, to?, type?, groupBy?, branchId?, demandIds?, supplyId?, agentIds?) {
    return this.$http.get(this.base_url + '/deliveriesCompletion/export', {
      params: {
        siteId: this.splitService.getSiteId(),
        from: from,
        to: to,
        type: type,
        branchId: branchId,
        demandIds: demandIds,
        supplyIds: supplyId,
        agentIds: agentIds,
        groupBy: groupBy,
        zoneId: this.splitService.getTimeZone()
      },
      responseType: "arraybuffer"
    })
      .then((response) => {
        return this._sendResponseData(response);
      })
      .catch((error) => {
        return this._sendError(error);
      })
  }

  getTasksAccuracyReport(tq?, from?, to?, type?, groupBy?, branchId?, demandIds?, supplyId?, agentIds?) {
    return this.$http.get(this.base_url + '/tasksAccuracy', {
      params: {
        siteId: this.splitService.getSiteId(),
        tq: tq,
        from: from,
        to: to,
        type: type,
        groupBy: groupBy,
        branchIds: branchId,
        demandIds: demandIds,
        supplyIds: supplyId,
        agentIds: agentIds,
        zoneId: this.splitService.getTimeZone()
      }
    })
      .then((response) => {
        return this._sendResponseData(response);
      })
      .catch((error) => {
        return this._sendError(error);
      })
  }

  getTasksAccuracyTotalsReport(tq, from, to, type, branchId, demandIds, supplyId, agentIds) {
    return this.$http.get(this.base_url + '/tasksAccuracy/total', {
      params: {
        siteId: this.splitService.getSiteId(),
        tq: tq,
        from: from,
        to: to,
        type: type,
        branchIds: branchId,
        demandIds: demandIds,
        supplyIds: supplyId,
        agentIds: agentIds,
        zoneId: this.splitService.getTimeZone()
      }
    })
      .then((response) => {
        return this._sendResponseData(response);
      })
      .catch((error) => {
        return this._sendError(error);
      })
  }

  exportTasksAccuracy(from?, to?, type?, groupBy?, branchId?, demandIds?, supplyId?, agentIds?) {
    return this.$http.get(this.base_url + '/tasksAccuracy/export', {
      params: {
        siteId: this.splitService.getSiteId(),
        from: from,
        to: to,
        type: type,
        branchId: branchId,
        demandIds: demandIds,
        supplyIds: supplyId,
        agentIds: agentIds,
        groupBy: groupBy,
        zoneId: this.splitService.getTimeZone()
      },
      responseType: "arraybuffer"
    })
      .then((response) => {
        return this._sendResponseData(response);
      })
      .catch((error) => {
        return this._sendError(error);
      })
  }

  getServiceAreasReport(tq, from, to, type, groupBy, branchId, demandIds, supplyId, agentIds, tagNames) {
    return this.$http.get(this.base_url + '/deliveriesByArea', {
      params: {
        siteId: this.splitService.getSiteId(),
        tq: tq,
        from: from,
        to: to,
        type: type,
        groupBy: groupBy,
        branchIds: branchId,
        demandIds: demandIds,
        supplyIds: supplyId,
        agentIds: agentIds,
        tagNames: tagNames,
        zoneId: this.splitService.getTimeZone()
      }
    })
      .then((response) => {
        return this._sendResponseData(response);
      })
      .catch((error) => {
        return this._sendError(error);
      })
  }

  getServiceAreasTotalsReport(tq, from, to, type, branchId, demandIds, supplyId, agentIds) {
    return this.$http.get(this.base_url + '/deliveriesByArea/total', {
      params: {
        siteId: this.splitService.getSiteId(),
        tq: tq,
        from: from,
        to: to,
        type: type,
        branchIds: branchId,
        demandIds: demandIds,
        supplyIds: supplyId,
        agentIds: agentIds,
        zoneId: this.splitService.getTimeZone()
      }
    })
      .then((response) => {
        return this._sendResponseData(response);
      })
      .catch((error) => {
        return this._sendError(error);
      })
  }

  exportDeliveriesByArea(from, to, branchIds, demandIds, supplyIds, agentIds, groupBy, tagNames) {
    return this.$http.get(this.base_url + '/deliveriesByArea/export', {
      params: {
        siteId: this.splitService.getSiteId(),
        from: from,
        to: to,
        branchIds: branchIds,
        demandIds: demandIds,
        supplyIds: supplyIds,
        agentIds: agentIds,
        groupBy: groupBy,
        tagNames: tagNames,
        zoneId: this.splitService.getTimeZone()
      },
      responseType: "arraybuffer"
    })
      .then((response) => {
        return this._sendResponseData(response);
      })
      .catch((error) => {
        return this._sendError(error);
      })
  }

  getActivityReport(ul?, tq?, from?, to?, type?, groupBy?, branchId?, demandIds?, supplyId?, agentIds?) {
    return this.$http.get(this.base_url + '/deliveriesTime', {
      params: {
        siteId: this.splitService.getSiteId(),
        ul: ul,
        tq: tq,
        from: from,
        to: to,
        type: type,
        groupBy: groupBy,
        branchIds: branchId,
        demandIds: demandIds,
        supplyIds: supplyId,
        agentIds: agentIds,
        zoneId: this.splitService.getTimeZone()
      }
    })
      .then((response) => {
        return this._sendResponseData(response);
      })
      .catch((error) => {
        return this._sendError(error);
      })
  }

  getActivityTotalsReport(tq, from, to, type, branchId, demandIds, supplyId, agentIds) {
    return this.$http.get(this.base_url + '/deliveriesTime/total', {
      params: {
        siteId: this.splitService.getSiteId(),
        tq: tq,
        from: from,
        to: to,
        type: type,
        branchIds: branchId,
        demandIds: demandIds,
        supplyIds: supplyId,
        agentIds: agentIds,
        zoneId: this.splitService.getTimeZone()
      }
    })
      .then((response) => {
        return this._sendResponseData(response);
      })
      .catch((error) => {
        return this._sendError(error);
      })
  }

  exportDeliveriesTime(from, to, type, groupBy, branchId, demandIds, supplyId, agentIds) {
    return this.$http.get(this.base_url + '/deliveriesTime/export', {
      params: {
        siteId: this.splitService.getSiteId(),
        from: from,
        to: to,
        type: type,
        branchId: branchId,
        demandIds: demandIds,
        supplyIds: supplyId,
        agentIds: agentIds,
        groupBy: groupBy,
        zoneId: this.splitService.getTimeZone()
      },
      responseType: "arraybuffer"
    })
      .then((response) => {
        return this._sendResponseData(response);
      })
      .catch((error) => {
        return this._sendError(error);
      })
  }

  getServiceTimeReport(tq?, from?, to?, type?, groupBy?, branchId?, demandIds?, supplyId?, agentIds?) {
    return this.$http.get(this.base_url + '/serviceTime', {
      params: {
        siteId: this.splitService.getSiteId(),
        tq: tq,
        from: from,
        to: to,
        type: type,
        groupBy: groupBy,
        branchIds: branchId,
        demandIds: demandIds,
        supplyIds: supplyId,
        agentIds: agentIds,
        zoneId: this.splitService.getTimeZone()
      }
    })
      .then((response) => {
        return this._sendResponseData(response);
      })
      .catch((error) => {
        return this._sendError(error);
      })
  }

  getServiceTimeReportTotalReport(tq, from, to, type, branchId, demandIds, supplyId, agentIds) {
    return this.$http.get(this.base_url + '/serviceTime/total', {
      params: {
        siteId: this.splitService.getSiteId(),
        tq: tq,
        from: from,
        to: to,
        type: type,
        branchIds: branchId,
        demandIds: demandIds,
        supplyIds: supplyId,
        agentIds: agentIds,
        zoneId: this.splitService.getTimeZone()
      }
    })
      .then((response) => {
        return this._sendResponseData(response);
      })
      .catch((error) => {
        return this._sendError(error);
      })
  }

  exportServiceTime(from?, to?, type?, groupBy?, branchId?, demandIds?, supplyId?, agentIds?) {
    return this.$http.get(this.base_url + '/serviceTime/export', {
      params: {
        siteId: this.splitService.getSiteId(),
        from: from,
        to: to,
        type: type,
        branchId: branchId,
        demandIds: demandIds,
        supplyIds: supplyId,
        agentIds: agentIds,
        groupBy: groupBy,
        zoneId: this.splitService.getTimeZone()
      },
      responseType: "arraybuffer"
    })
      .then((response) => {
        return this._sendResponseData(response);
      })
      .catch((error) => {
        return this._sendError(error);
      })
  }

  getDriversReport(tq, from, to, agentIds, groupBy) {
    return this.$http.get(this.base_url + '/driversDeliveries', {
      params: {
        siteId: this.splitService.getSiteId(),
        from: from,
        to: to,
        tq: tq,
        agentIds: agentIds,
        groupBy: groupBy
      }
    })
      .then((response) => {
        return this._sendResponseData(response);
      })
      .catch((error) => {
        return this._sendError(error);
      })
  }

  getVendorsDeliveries(tq, from, to, supplyIds, agentIds, groupBy) {
    return this.$http.get(this.base_url + '/vendorsDeliveries', {
      params: {
        siteId: this.splitService.getSiteId(),
        from: from,
        to: to,
        tq: tq,
        supplyIds: supplyIds,
        agentIds: agentIds,
        groupBy: groupBy
      }
    })
      .then((response) => {
        return this._sendResponseData(response);
      })
      .catch((error) => {
        return this._sendError(error);
      })
  }

  getSisenseSsoData() {
    return this.$http.get(this.apiConfig.baseUrl + `/sisense/jwt`, {
      params: {
        siteId: this.splitService.getSiteId(),
      }
    })
      .then((response) => {
        return this._sendResponseData(response);
      })
      .catch((error) => {
        return this._sendError(error);
      })
  }

  getAccountsDeliveries(tq, from, to, demandIds, groupBy) {
    return this.$http.get(this.base_url + '/accountsDeliveries', {
      params: {
        siteId: this.splitService.getSiteId(),
        from: from,
        to: to,
        tq: tq,
        demandIds: demandIds,
        groupBy: groupBy
      }
    })
      .then((response) => {
        return this._sendResponseData(response);
      })
      .catch((error) => {
        return this._sendError(error);
      })
  }

  getAgentsPerformanceDetails(params) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.$http.get(this.base_url + '/agent/agentPerformanceSummary', {
      params: {
        // from,
        // to,
        // branchIds,
        // agentIds,
        // agentTypes,
        // limit,
        // offset,
        ...params,
        siteId: this.splitService.getSiteId(),
        zoneId: this.splitService.getTimeZone()
      }
    })
      .then(res => {
        deferred.resolve(res.data);
      })
      .catch(err => {
        deferred.reject(err.data);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });


    return deferred.promise;
  }

  getAgentRoutesPerformance(params) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.$http.get(this.base_url + '/agent/agentRoutePerformance', {
      params: {
        ...params,
        siteId: this.splitService.getSiteId(),
        zoneId: this.splitService.getTimeZone()
      }
    })
      .then(res => {
        deferred.resolve(res.data);
      })
      .catch(err => {
        deferred.reject(err.data);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  getAgentRoutesPerformanceSummary(params) {
    const deferred = this.$q.defer();
    this.$http.get(this.base_url + '/agent/totalAgentsPerformance', {
      params: {
        ...params,
        siteId: this.splitService.getSiteId(),
        zoneId: this.splitService.getTimeZone()
      }
    })
      .then(res => {
        deferred.resolve(res.data);
      })
      .catch(err => {
        deferred.reject(err.data);
      })

    return deferred.promise;
  }


  // ******************************
  //        Private methods
  // ******************************


  private _sendResponseData(response) {
    return this.$q.resolve(response.data);
  }

  private _sendError(response) {
    return this.$q.reject(response.data);
  }

}

angular
  .module('bringoz.admin.reports')
  .service('reportsRequests', ReportsRequests);
